export default "__VITE_ASSET__DjDMMpnv__"